__turbopack_context__.v({
  "bottomContainer": "OutletDetailsModal-module-scss-module__aBM3PG__bottomContainer",
  "container": "OutletDetailsModal-module-scss-module__aBM3PG__container",
  "modal": "OutletDetailsModal-module-scss-module__aBM3PG__modal",
  "modalHeader": "OutletDetailsModal-module-scss-module__aBM3PG__modalHeader",
  "topContainer": "OutletDetailsModal-module-scss-module__aBM3PG__topContainer",
});
